import React, { useEffect, useRef } from "react";

import styled from "styled-components";


const PriceMatic = styled.div`
  font-family: 'IBM Plex Mono', monospace;;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: center;

  color: #FFFFFF;
`;

const PriceUSD = styled.div`
  font-family: 'IBM Plex Mono', monospace;;
  font-style: normal;
  font-weight: normal;
  font-size: 11px;
  line-height: 14px;
  display: flex;
  align-items: center;
  color: #FFFFFF;
  opacity: 0.45;
`;

const Bidder = styled.a`
  font-family: 'IBM Plex Mono', monospace;;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: flex-start;
  text-align: left;
  color: #FFFFFF;
  flex: 1;
  justify-content: center;
`;


const Time = styled.div`
  font-family: 'IBM Plex Mono', monospace;;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: center;
  text-align: right;
  color: #FFFFFF;  
  flex: 1;
  justify-content: flex-end;
`;

const url = window.location;
let domain = (new URL(url));
domain = domain.origin;

function BidListComponent(props){

    if(!props.bids || props.bids.length === 0){
        return (<></>)
    }

    const secondsToTime = (secs) =>{
        let days = Math.floor(secs / (60 * 60 * 24));
        let hours = Math.floor(secs / (60 * 60));
        
        let divisor_for_minutes = secs % (60 * 60);
        let minutes = Math.floor(divisor_for_minutes / 60);
        
        let divisor_for_seconds = divisor_for_minutes % 60;
        let seconds = Math.ceil(divisor_for_seconds);                        

        if(days<0){
            days = 0;
        }
        if(hours<0){
            hours = 0;
        }
        if(minutes<0){
            minutes = 0;
        }
        if(seconds<0){
            seconds = 0;
        }
        let obj = {
            "d": days,
            "h": hours,
            "m": minutes,
            "s": seconds
        };
        return obj;
    }
        
    let bid_temp = [...props.bids];
    bid_temp.reverse();
    const bids = bid_temp.map((item, index) => {
        let value = item.value;
        let bidder = item.username;
        const link = `${domain}/address/${item.username}`;
        var t = secondsToTime(new Date().getTime()/1000 - new Date(item.createdAt).getTime()/1000);
            var time;
        if(t.d > 0)
            time = `${t.d}d ago`;
        else
            if(t.h > 0)
                time = `${t.h}h ${t.m}m ago`;
            else
                time = `${t.m}m ago`;
                
        return (
            <div style={{borderBottom: '1px solid rgba(255,255,255,0.05)', display: 'flex', justifyContent: 'space-between', paddingTop: 11, paddingBottom: 11, alignItems: 'flex-start'}}>
                <div style={{display: 'flex', justifyContent: 'space-between', flexDirection: 'column', flex: 1 }}>
                    <PriceMatic>{value} {item.bidCurrency}</PriceMatic>
                </div>
                <Bidder href={link}
                    onClick={() => {
                        window.analytics.track('bidder_username_clicked', {
                            type: 'web',
                            from: 'TopCard',
                            ...item
                        });
                    }}
                >
                    {bidder}
                </Bidder>
                <Time>
                    {time}
                </Time>             
            </div>
        );
    });
    
    return (
        <div style={{paddingLeft: 18, paddingRight: 18}}>
            {bids}
        </div>);
}
BidListComponent = React.memo(BidListComponent);
export default BidListComponent;
